"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DVLTableItemDeleteButton = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDVL_1 = __importDefault(require("@opsbase/web-dvl/useDVL"));
const DeleteIcon_1 = __importDefault(require("@opsbase/web-icons/icons/DeleteIcon"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav"));
const IconButton_1 = __importDefault(require("@opsbase/web-ui/IconButton"));
const react_1 = __importStar(require("react"));
const makeMyClasses = () => ({
    root: {
        position: 'sticky',
        right: 4,
        margin: 4,
        width: 28,
        height: 28,
        background: lib_palette_1.default.White.main,
        border: `1px solid ${lib_palette_1.default.LavendarGrey.main}`,
        '&:hover .SVGIconRoot': {
            color: `${lib_palette_1.default.error.main} !important`,
        },
    },
});
function DVLTableItemDeleteButton({ item }) {
    const { itemDeletePage } = (0, useDVL_1.default)();
    const { goTo } = (0, useNav_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleClick = (0, react_1.useCallback)(() => {
        const page = typeof itemDeletePage === 'function' ? itemDeletePage(item) : itemDeletePage;
        goTo(page, { id: item.id });
    }, [goTo, item, itemDeletePage]);
    return (react_1.default.createElement(IconButton_1.default, { round: true, noOpacity: true, onClick: handleClick, classes: { root: myCss.root }, icon: react_1.default.createElement(DeleteIcon_1.default, { size: 20, color: lib_palette_1.default.GreyBlue }) }));
}
exports.DVLTableItemDeleteButton = DVLTableItemDeleteButton;
exports.default = DVLTableItemDeleteButton;
